(() => {
  if (window.__pdlShippingRequestControl || typeof window.fetch !== 'function') return;
  const configElement = document.getElementById('pdl-shipping-stock');
  if (!configElement) return;
  let stock;
  try { stock = JSON.parse(configElement.textContent); } catch (_) { return; }
  const nativeFetch = window.fetch.bind(window);
  const cache = new Map();
  const cacheLifetime = 5 * 60 * 1000;
  const delay = 650;
  const state = { version: '1.0.0', networkRequests: 0, cacheHits: 0, combinedRequests: 0, unavailableRequests: 0 };
  window.__pdlShippingRequestControl = state;
  let latest = null;
  let waiters = [];
  let running = false;
  let timer = null;
  let due = 0;

  const selectedId = () => new URL(window.location.href).searchParams.get('variant') || String(stock.selected || '');
  const available = () => stock.variants?.[selectedId()] !== false;
  const syncStock = () => {
    document.documentElement.dataset.pdlShippingUnavailable = available() ? 'false' : 'true';
  };
  syncStock();

  for (const name of ['pushState', 'replaceState']) {
    const original = history[name];
    history[name] = function (...args) {
      const result = original.apply(this, args);
      syncStock();
      return result;
    };
  }
  window.addEventListener('popstate', syncStock);
  document.addEventListener('variant:update', (event) => {
    const section = event.target?.closest?.('.product-information');
    if (!section) return;
    const detail = event.detail || {};
    const nextConfig = detail.data?.html?.getElementById?.('pdl-shipping-stock');
    if (nextConfig) {
      try { stock = JSON.parse(nextConfig.textContent); } catch (_) {}
    }
    const variant = detail.resource;
    if (variant?.id) {
      stock.selected = variant.id;
      stock.variants ||= {};
      if (variant.available === false) stock.variants[String(variant.id)] = false;
      else if (!(String(variant.id) in stock.variants)) stock.variants[String(variant.id)] = variant.available === true;
    }
    syncStock();
  });

  const keyFor = (body) => JSON.stringify({
    shop: body.shop,
    origin: body.origin,
    cep: String(body.cep || '').replace(/\D/g, ''),
    items: (body.items || []).map((item) => ({
      variant_id: String(item.variant_id),
      quantity: Number(item.quantity || 1),
      price: Number(item.price || 0),
      sku: item.sku || null
    }))
  });
  const emptyResponse = () => new Response('[]', { status: 200, headers: { 'Content-Type': 'application/json' } });
  const finish = (response, error) => {
    const current = waiters;
    waiters = [];
    latest = null;
    clearTimeout(timer);
    timer = null;
    for (const waiter of current) {
      if (error) waiter.reject(error);
      else waiter.resolve(response.clone());
    }
  };
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(flush, Math.max(0, due - Date.now()));
  };
  const remember = async (key, response) => {
    if (!response.ok) return;
    try {
      const data = await response.clone().json();
      if (!Array.isArray(data) || !data.length) return;
      cache.set(key, { response: response.clone(), expires: Date.now() + cacheLifetime });
      while (cache.size > 20) cache.delete(cache.keys().next().value);
    } catch (_) {}
  };
  const flush = async () => {
    timer = null;
    if (running || !latest) return;
    if (Date.now() < due) { schedule(); return; }
    if (!available()) {
      state.unavailableRequests += 1;
      finish(emptyResponse());
      return;
    }
    const request = latest;
    const cached = cache.get(request.key);
    if (cached && cached.expires > Date.now()) {
      state.cacheHits += 1;
      finish(cached.response);
      return;
    }
    if (cached) cache.delete(request.key);
    running = true;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    const abort = () => controller.abort(request.init.signal?.reason);
    if (request.init.signal?.aborted) abort();
    request.init.signal?.addEventListener('abort', abort, { once: true });
    try {
      state.networkRequests += 1;
      const response = await nativeFetch(request.input, { ...request.init, signal: controller.signal });
      await remember(request.key, response);
      if (latest === request) finish(available() ? response : emptyResponse());
    } catch (error) {
      if (latest === request) finish(null, error);
    } finally {
      clearTimeout(timeout);
      request.init.signal?.removeEventListener('abort', abort);
      running = false;
      if (latest) schedule();
    }
  };

  window.fetch = function (input, init) {
    let body;
    try {
      const url = new URL(typeof input === 'string' ? input : input.url, window.location.href);
      if (url.hostname !== 'calculo-frete-produto.kokfy.com' || url.pathname !== '/api/carrier/shopify' || String(init?.method || '').toUpperCase() !== 'POST' || typeof init?.body !== 'string') return nativeFetch(input, init);
      body = JSON.parse(init.body);
      if (!Array.isArray(body.items)) return nativeFetch(input, init);
    } catch (_) { return nativeFetch(input, init); }
    const key = keyFor(body);
    if (latest?.key === key) state.combinedRequests += 1;
    else {
      latest = { input, init, key };
      due = Date.now() + delay;
    }
    const promise = new Promise((resolve, reject) => waiters.push({ resolve, reject }));
    if (!running) schedule();
    return promise;
  };
})();
